
import store from '@/store';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  components: {},
  computed: {
    ...mapState(['storeSelectedStates', 'availableStates']),
  },
})
export default class StateSelect extends Vue {
  @Prop(String) private readonly context!: string;

  private availableStates!: string[];
  private selectedStates: string[] = [];
  private storeSelectedStates!: string[];

  private toggleAllStates(): void {
    if (this.selectedStates.length === this.availableStates.length) {
      this.selectedStates = [];
    } else {
      this.selectedStates = this.availableStates;
    }
  }

  private get toggleAllStatesIcon(): string {
    if (this.selectedStates.length === 0) {
      return 'mdi-checkbox-blank-outline';
    } else if (this.selectedStates.length === this.availableStates.length) {
      return 'mdi-checkbox-marked';
    } else {
      return 'mdi-minus-box';
    }
  }
  @Watch('selectedStates')
  private setSelectedStates() {
    this.$emit('change', this.selectedStates);
    store.dispatch('setSelectedStates', this.selectedStates);
  }

  private mounted(): void {
    this.selectedStates = this.storeSelectedStates || this.availableStates;
  }
}
